<template>
<!-- 限制文件大小可以传值20230925 -->
  <div class="zujian">
   <el-dialog title="导入" center :visible.sync="importDialog" @close="closeDialogFile" width="300px" top="20px" >
     <input type="file" ref="file"   accept=".xls,.csv,.xlsx"   @change="getFile($event)">
     <div slot="footer" class="dialog-footer">
       <el-button @click="closeDialogFile" size="mini">取 消</el-button>
       <el-button type="primary" @click="DRsave()" size="mini">确 定</el-button>
     </div>
   </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'uploadImg',
  props: {
    importDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      file: null,
      size: 5000
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.importDialog = true
  },
  methods: {
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    DRsave (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        };
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      if (this.file == null) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else {
        let name = extname(this.file.name)
        if (name != 'xlsx' && name != 'csv' && name != 'xls') { // xls,.csv
          this.$alert('请选择正确的文件格式', '系统提示')
        } else {
          if (this.danwei == 'KB') {
            if (this.file.size > this.size * 1024) {
              this.$alert('文件不能大于' + this.size + 'KB', '系统提示')
            } else {
              let formData = new FormData()
              formData.append('file', this.file)
              this.jiekou(formData)
            }
          } else {
            if (this.file.size > this.size * 1024 * 1024) {
              this.$alert('文件不能大于' + this.size + 'M', '系统提示')
            } else {
              let formData = new FormData()
              formData.append('file', this.file)
              this.jiekou(formData)
            }
          }
        }
      }
    },
    jiekou (formData) {
      formData.append('MultipartFile', 'excl')
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      impCustomerExcel(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        that.getList(that.searchFrom)
        this.msg = this.$message({
          showClose: true,
          message: res,
          duration: 0,
          type: 'success',
          onClose () {

          }
        })
      }).catch(error => {
        this.msg = this.$message({
          showClose: true,
          message: error.message,
          duration: 0,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialogFile () {
      this.$emit('update:importDialog', false)
      this.$refs.file.value = ''
      this.file = null
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
